import { render, staticRenderFns } from "./ImagePlus.vue?vue&type=template&id=797e0988"
import script from "./ImagePlus.vue?vue&type=script&lang=js"
export * from "./ImagePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports